var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-container"},[_c('headerIndex'),_c('div',{staticClass:"user-content"},[_c('userinfo',{attrs:{"info":_vm.info},on:{"attentSuccess":_vm.attentSuccess}}),_c('AuthorContent',{attrs:{"info":_vm.info}})],1),_c('hang'),_c('home_footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }